import type { CompanySource, PlatformCompany } from '../../../types';
import type { CompanyRowDisplayFlags } from './types';
import { AliIntlCompanyCard, MadeInChinaCompanyCard, GlobalCompanyCard } from './company-cards';

export interface CompanyCardPortalProps {
  company: PlatformCompany;
  source: CompanySource;
  displayFlags: CompanyRowDisplayFlags;
  className?: string;
}

/**
 * CompanyCardPortal — 供应商卡片统一入口
 *
 * 根据 `source` 字段将渲染分发到对应的平台卡片组件：
 * - `ALI_INTL`      → AliIntlCompanyCard
 * - `MADE_IN_CHINA` → MadeInChinaCompanyCard
 * - `GLOBAL`        → GlobalCompanyCard
 */
export function CompanyCardPortal({ company, source, displayFlags, className }: CompanyCardPortalProps) {
  if (source === 'ALI_INTL') {
    return <AliIntlCompanyCard company={company} displayFlags={displayFlags} className={className} />;
  }
  if (source === 'MADE_IN_CHINA') {
    return <MadeInChinaCompanyCard company={company} displayFlags={displayFlags} className={className} />;
  }
  // GLOBAL（fallback）
  return <GlobalCompanyCard company={company} displayFlags={displayFlags} className={className} />;
}
